module.exports = __webpack_public_path__ + "static/img/YellowBubble@2x.de18ece.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pride/places/YellowBubble@2x.png
// module id = u5+t
// module chunks = 0